import { render, staticRenderFns } from "./BEditorCheckbox.vue?vue&type=template&id=760287be"
import script from "./BEditorCheckbox.vue?vue&type=script&lang=js"
export * from "./BEditorCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports